import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from "@angular/forms";
import { CustomValidators } from "ng2-validation/dist";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService, FormHelperService, AppSettingsService } from "../core/services/index";

@Component({
    moduleId: module.id,
    templateUrl: 'reset-password.component.html'
})

export class ResetPassWordComponent implements OnInit {
    resetPassWordForm: FormGroup;
    ValidationMessages: any = {};
    showInvalidTokenMessage: boolean;
    showResetPasswordConfirmationMessage: boolean;
    private token: string;

    constructor(
        private activatedRoute: ActivatedRoute,
        private authService: AuthService,
        private formBuilder: FormBuilder,
        private formHelperService: FormHelperService,
        private appSettingsService: AppSettingsService,
        private router: Router
    ) { }

    ngOnInit() {
        this.token = this.activatedRoute.snapshot.params["token"];

        let _passWord = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]);
        let _confirmPassword = new FormControl('', [CustomValidators.equalTo(_passWord)]);
        this.resetPassWordForm = this.formBuilder.group({
            passWord: _passWord,
            confirmPassWord: _confirmPassword
        });
    }

    resetPassWordSubmit(event: any) {
        event.preventDefault();
        if (!this.resetPassWordForm)
            return;

        this.showInvalidTokenMessage = false;
        this.authService.sendResetPassword(this.token, this.resetPassWordForm.value.passWord).subscribe((resp) => {
            this.showResetPasswordConfirmationMessage = true;
        }, (error: any) => this.showInvalidTokenMessage = true);
    }

    onLogin(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.router.navigate([this.appSettingsService.LoginPath]);
    }

    showErrorMessage(form: FormGroup, controlName: string, validator: string): boolean {
        return this.formHelperService.showErrorMessage(form, controlName, validator)
    }
}


// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.component.ts